import { DcScheduleProgressItem } from '../domain/dc-schedule.model';

export function scheduleProgressTooltip(
  progressPercentage: number,
  breakdown: DcScheduleProgressItem[]
): string {
  const header = `Overall progress: ${progressPercentage}/100%`;
  if (!breakdown?.length) {
    return header;
  }

  return [
    header,
    ...breakdown.map((item) => {
      const marker = item.earned === item.weight ? '✓' : '○';
      return `${marker} ${item.label}: ${item.earned}/${item.weight}% — ${progressItemExplanation(
        item
      )}`;
    })
  ].join('\n');
}

function progressItemExplanation(item: DcScheduleProgressItem): string {
  switch (item.state) {
    case 'complete':
      return item.code === 'VIDEO' ? 'available' : 'done';
    case 'not_required':
      return 'not required';
    case 'pending':
      return 'status is not done';
    case 'missing':
      return item.code === 'VIDEO' ? 'video is missing' : 'missing from roster';
  }
}
